<label class="form-label mb-2">
    {{ "government_scores.sectors.color" | translate }}
    @if (isRequired() || showAsRequired()) {
        <span class="form-required text-danger fw-bolder">*</span>
    }
</label>
<div class="border rounded p-3">
    <input
        class="color"
        readonly
        [class.disabled]="pageMode() === PageMode.view"
        cpPosition="right"
        [cpWidth]="'600px'"
        [(colorPicker)]="_color"
        [style.background]="_color"
        (colorPickerChange)="onChange($event)"
    />
</div>
